import React from 'react';

import './ColorIndicator.scss';

export const ColorIndicator = ({ color }) => {
  return <div className="color-indicator__cell" style={{ backgroundColor: color }}></div>;
};
